export function getAnalyticsId() {
  return 48925235
}
